export default class DtoSTEPAssociatedTown {
    constructor(obj) {
        this.idStation = obj.idStation // Long,
        this.code = obj.code // Option[String],
        this.totalSevice = obj.totalSevice // Option[Boolean],
        this.nbFollow = obj.nbFollow // Option[Long]
    }
}